(ns ycweb.app.website.products.components.gallery
  (:require
   [rum.core :as rum]
   [clojure.string :as str]
   [util.transform :as trf]
   [ycweb.util.core :as yuc]
   [ycweb.util.comms :as comms]))

(defn- cloudinary-url
  [{:keys [public-id width height mode]}]
  (when (and public-id (not (str/blank? (str public-id))))
    (let [crop (or mode "c_limit")]
      (str "https://res.cloudinary.com/yuppiechef/image/upload/"
        (when (and width height) (str "w_" width ",h_" height ","))
        crop "/" public-id ".jpg"))))

(defn get-alt-text [image content-name]
  (let [{:doc/keys [alt-tag picture-type]} image]
    (cond
      (not (str/blank? alt-tag)) alt-tag
      (not (str/blank? picture-type)) (str picture-type " image of " content-name)
      :else content-name)))

(defn get-zoom-src [image]
  (cloudinary-url
    {:public-id (:doc/public-id image)
     :width 1024 :height 1024 :mode "c_fit"}))

(defn get-display-src [image]
  (cloudinary-url {:public-id (:doc/public-id image) :width 600 :height 600}))

(defn- url-imageindex []
  #?(:cljs
     (when-let [params (js/URLSearchParams. js/window.location.search)]
       (let [n (js/parseInt (.get params "imageindex") 10)]
         (when (and (not (js/isNaN n)) (pos? n)) n)))
     :clj nil))

(def ^:private help-article-four-for-three-sale 312)
(def ^:private category-100-favourite-things 7224)

(rum/defc variation-image-gallery-stickers < rum/static [content variation]
  (let [all-cats (:allcats content)
        ratio-spec (:product/ratio-special content)
        features (:features content)
        made-in (get-in features ["madein" :formattedvalue])
        is-100-faves? (some #(= (:category/refers-to %) category-100-favourite-things) all-cats)
        has-ratio-special? (= 1 (:special/has-special ratio-spec))
        has-time-special? (= 1 (:product/has-time-based-special content))
        is-new? (trf/toboolean (:variation/new variation))
        is-exclusive? (trf/toboolean (:variation/exclusive variation))
        is-made-in-sa? (= made-in "South Africa")]

    [:div
     (cond
       is-100-faves?
       [:div.gallery-view-stickers.gallery-view-stickers--left
        [:span.text-pill.u-bg-gold.u-text-white "100 Favourite Things"]]

       has-ratio-special?
       (let [qty (:special/ratio-qty ratio-spec)
             free (:special/cheapest-free ratio-spec)
             pay-for (- qty free)]
         [:div.gallery-view-stickers.gallery-view-stickers--left
          [:a.gallery-view-promo-graphic.tooltip.tooltip--right
           {:href "/help.htm?action=article&id=312"
            :data-tooltip "Find out more"
            :on-click
            (fn [e]
              (.preventDefault e)
              (comms/ajax-get :web.product/help-article
                {:help-article #:help-article{:id help-article-four-for-three-sale}}))}
           [:div.deal-ratio-icon
            [:span.deal-ratio-icon__int qty]
            [:span.deal-ratio-icon__for "for"]
            [:span.deal-ratio-icon__int pay-for]]]])

       has-time-special?
       [:div.gallery-view-stickers.gallery-view-stickers--left
        [:span.gallery-view-promo-graphic.gallery-view-promo-graphic--time-based]]

       (and is-new? (not has-time-special?))
       [:ul.gallery-view-stickers.gallery-view-stickers--left
        [:li.gallery-view-stickers__item
         [:span.gallery-view-stickers__pill.text-pill.u-text-uppercase.u-bg-oil "New"]]])

     (when (or is-made-in-sa? is-exclusive?)
       [:ul.gallery-view-stickers.gallery-view-stickers--right
        (when is-made-in-sa?
          [:li.gallery-view-stickers__item
           [:span.gallery-view-stickers__pill.text-pill.u-text-uppercase.u-bg-greenery
            "Made in S" [:span.clip-text.unclip-text--l "outh "] "A" [:span.clip-text.unclip-text--l "frica"]]])

        (when is-exclusive?
          [:li.gallery-view-stickers__item
           [:span.gallery-view-stickers__pill.text-pill.u-text-uppercase.u-bg-greenery
            "Exclusive to Yuppiechef"]])])]))

(rum/defcs image-guide-toggle < (rum/local false ::open?)
  [state]
  (let [open? (::open? state)]
    [:div.gallery-image-guide
     [:div
      {:class
       (str "js-product-image-guide yc-product-image-guide"
         (when @open? " yc-product-image-guide--is-open"))}]
     [:div.product-image-guide-button-wrapper
      [:a.product-image-guide-button.tooltip.tooltip--right
       {:href "#"
        :data-tooltip (if @open? "Hide Guides" "Show Guides")
        :on-click
        (fn [e]
          (.preventDefault e)
          (swap! open? not))}
       [:i.icon.icon--block.icon--guides.icon--is-light]
       [:span.u-hidden-from-view "Toggle Image Guidelines"]]]]))

(rum/defcs content-images <
  (rum/local {:index 0 :variation-id nil} ::selection)
  (rum/local nil ::touch-state)
  [state content variation & [{:keys [on-zoom-click on-video-click show-image-guide? videos video-count]}]]
  (let [selection (::selection state)
        touch-state (::touch-state state)
        {:variation/keys [user-hash]} variation
        images
        (filter
          #(and (:doc/public-id %) (not (str/blank? (str (:doc/public-id %)))))
          (:variation/images variation))
        {:product/keys [content-name]} content
        show-high-res? (and (:variation/show-highres variation) user-hash)
        sel @selection
        active
        (if (= (:variation/id variation) (:variation-id sel))
          (min (:index sel) (max 0 (dec (count images))))
          (let [url-idx (or (url-imageindex) 0)]
            (min url-idx (max 0 (dec (count images))))))]

    [:div.js-mainpic-image.gallery-view-wrapper

     [:div.gallery-view
      [:div.gallery-view__track
       {:style {:transform (str "translateX(-" (* active 100) "%)")}
        :on-touch-start
        (fn [e]
          (let [touch (aget (.-changedTouches e) 0)]
            (reset! touch-state {:start-x (.-clientX touch) :start-y (.-clientY touch)})))
        :on-touch-end
        (fn [e]
          (when-let [{:keys [start-x start-y]} @touch-state]
            (let [touch (aget (.-changedTouches e) 0)
                  dx (- (.-clientX touch) start-x)
                  dy (- (.-clientY touch) start-y)
                  adx (if (neg? dx) (- dx) dx)
                  ady (if (neg? dy) (- dy) dy)]
              (when (> adx (max 50 ady))
                (let [new-idx (if (neg? dx)
                                (min (dec (count images)) (inc active))
                                (max 0 (dec active)))]
                  (reset! selection {:index new-idx :variation-id (:variation/id variation)}))))))
        :on-mouse-down
        (fn [e]
          (.preventDefault e)
          (reset! touch-state {:start-x (.-clientX e) :start-y (.-clientY e)}))
        :on-mouse-up
        (fn [e]
          (when-let [{:keys [start-x start-y]} @touch-state]
            (let [dx (- (.-clientX e) start-x)
                  dy (- (.-clientY e) start-y)
                  adx (if (neg? dx) (- dx) dx)
                  ady (if (neg? dy) (- dy) dy)]
              (when (> adx (max 50 ady))
                (let [new-idx (if (neg? dx)
                                (min (dec (count images)) (inc active))
                                (max 0 (dec active)))]
                  (reset! selection {:index new-idx :variation-id (:variation/id variation)}))))))}
       (map-indexed
         (fn [idx image]
           (let [alt-text (get-alt-text image content-name)]
             [:div.gallery-view__item
              {:key (:doc/id image)}
              (when-let
                [img-src
                 (cloudinary-url {:public-id (:doc/public-id image) :width 640 :height 640})]
                [:img.yc-simple-image.yc-simple-image--full
                 {:src img-src
                  :width "640"
                  :height "640"
                  :alt alt-text}])

              (when (not (str/blank? (:doc/description image)))
                [:span.gallery-image-label.text-pill.text-pill--medium.text-pill--light
                 (:doc/description image)])

              [:a.gallery-image-action-button.gallery-image-action-button--zoom.button.button--default.button--flat-to-raised.button--has-icon-only.button--circle
               {:href "#"
                :on-click
                (fn [e]
                  (.preventDefault e)
                  (when on-zoom-click
                    (on-zoom-click images active)))}
               [:span.button__text
                [:i.icon.icon--zoom.icon--block.icon--default.icon--is-dark]
                [:span.u-hidden-from-view "Zoom image"]]]

              (when show-high-res?
                [:a.gallery-image-action-button.gallery-image-action-button--download.button.button--default.button--flat-to-raised.button--has-icon-only.button--circle.tooltip.tooltip--left
                 {:href
                  (str "/api/download?h=" user-hash
                    "&image=" (:doc/id image)
                    "&extension=jpg")
                  :target "_blank"
                  :data-tooltip (str (:doc/original-width image) " x " (:doc/original-height image) "px")}
                 [:span.button__text
                  [:i.icon.icon--block.icon--default.icon--is-dark.icon--download]
                  [:span.u-hidden-from-view "Download image"]]])]))
         images)]

      (when show-image-guide?
        (image-guide-toggle))

      (variation-image-gallery-stickers content variation)]

     (when (> (count images) 1)
       [:ul.gallery-stops
        (map-indexed
          (fn [idx _]
            [:li.gallery-stops__item {:key idx}
             [:a.gallery-stops__link
              {:href "#"
               :class (when (= idx active) "gallery-stops__link--is-active")
               :on-click
               (fn [e]
                 (.preventDefault e)
                 (reset! selection {:index idx :variation-id (:variation/id variation)}))}
              [:span.u-hidden-from-view
               (str "View image " (pr-str idx))]]])
          images)])

      [:nav.gallery-nav-wrapper
       [:ul.gallery-nav

        (when (>= (or video-count 0) 1)
          [:li.gallery-nav__item
           [:a.gallery-nav-video-button
            {:href "#"
             :on-click
             (fn [e]
               (.preventDefault e)
               (when on-video-click
                 (on-video-click)))}
            [:span.u-text-center
             [:i {:class (yuc/bem :icon [:video :default :inline])}]
             [:span.u-block (str "Video" (when (> (or video-count 0) 1) "s"))]]]])

        (map-indexed
          (fn [idx image]
            [:li.gallery-nav__item
             {:key (str "thumb-" (:doc/id image))
              :class (when (= idx active) "gallery-nav__item--active")
              :on-click (fn [_] (reset! selection {:index idx :variation-id (:variation/id variation)}))}
             [:img.yc-simple-image.yc-simple-image--full
              {:src (cloudinary-url {:public-id (:doc/public-id image) :width 64 :height 64})
               :width "64"
               :height "64"
               :alt (:doc/alt-tag image)}]])
          images)]]]))
